/**
 * I really don't know how to typedef this. It just creates a new object that
 * has all the values copied over except for any keys that are defined in the
 * omitKeys param.
 *
 * @internal
 * @param object - The object to remove keys from
 * @param omitKeys - The keys to remove.
 * @returns a new object without the specified keys
 */
export function omit(object, omitKeys) {
    if (!omitKeys.length) {
        return object;
    }
    return Object.keys(object).reduce(function (updated, key) {
        if (!omitKeys.includes(key)) {
            updated[key] = object[key];
        }
        return updated;
    }, {});
}
//# sourceMappingURL=omit.js.map